@if (formGroup.get(property.Key)) {
  <mat-form-field [formGroup]="formGroup" floatLabel="always" [subscriptSizing]="showErrors ? 'fixed' : 'dynamic'" class="flex-form-field">
    @if (showLabel) {
      <mat-label>{{ property.TextId | translate }}</mat-label>
    }
    <input
      matInput
      type="text"
      inputmode="decimal"
      [id]="property.Key"
      [formControlName]="property.Key"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput()"
      [matTooltip]="toolTipTextId | translate"
    />
    @if (showMeasurementUnit) {
      <span matSuffix>{{ property.MeasurementUnitTextId | translate }}</span>
    }
    @if (propertyForm.errors && propertyForm.errors.required) {
      <mat-error>{{ 'UI.Error.Required' | translate }}</mat-error>
    }
    @if (propertyForm.errors && propertyForm.errors.numeric) {
      <mat-error>{{ 'UI.Error.Input.Numeric' | translate }}</mat-error>
    }

    <!-- Note that these errors are not displayed if the input value doesn't validate to a number -->
    @if (!propertyForm.errors?.numeric && propertyForm.errors && propertyForm.errors.min) {
      <mat-error>
        {{ 'UI.Error.ValueTooLow' | translate }}
      </mat-error>
    }
    @if (!propertyForm.errors?.numeric && propertyForm.errors && propertyForm.errors.max) {
      <mat-error>
        {{ 'UI.Error.ValueTooHigh' | translate }}
      </mat-error>
    }
  </mat-form-field>
}
